import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { FilterProvider } from 'context/FilterContext';
import { Filter } from 'styled_components/Common/Filter';
import parseISO from 'date-fns/parseISO';
import format from 'date-fns/format';

// const Filtering = ['ATL', 'BHM', 'CHA', 'GSP', 'HSV'];
const Filtering = ['BHM', 'CHA', 'GSP', 'HSV'];

const ForecastStyle = styled.button`
	width: 100%;
	height: 100%;
	background: ${props => props.theme.$DCBLOX_Gray};
	#filter {
		margin-top: -40px;
	}
	.stat {
		display: flex;
		align-items: center;
		justify-content: center;
		.value {
			margin-left: 5px;
		}
	}

	.forecast-wrapper {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100%;

		.forecast-list {
			display: flex;
			flex-direction: column;
			.forecast {
				padding: 10px;
				border: 1px solid black;
			}
		}
	}

	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
	}
`;

export const Forecast = () => {
	const [forecasts, setForecasts] = useState([]);
	const [properties, setProperties] = useState([]);
	const [lastUpdated, setLastUpdated] = useState('');
	const [selected, setSelected] = useState('ATL');
	console.log(properties);
	const getForecast = async () => {
		const { properties } = await DataCenterApi.getForecast(selected);
		setProperties(properties);
		setLastUpdated(properties?.updateTime);
		setForecasts(properties?.periods);
	};

	useEffect(() => {
		setForecasts([]);
		getForecast();
	}, [selected]);
	const timestamp = parseISO(lastUpdated);

	return (
		<ForecastStyle className='forecasts' data-cy='forecasts'>
			<div className='forecast-wrapper'>
				<FilterProvider>
					<Filter
						module='colo'
						selected={selected}
						options={Filtering}
						callback={setSelected}
						filterHeading='Data Center'
					/>
				</FilterProvider>

				<div className='forecast-list'>
					{forecasts &&
						forecasts.map(forecast => {
							if (forecast?.name === 'Today') {
								return (
									<div className='forecast'>
										<div>(ICON)</div>
										{/* <div className='body10'>{forecast?.shortForecast}</div> */}
										<div className='stat'>
											<div className='label labels21'>Temperature</div>
											<div className='value body10'>{forecast?.temperature}</div>
											<div className='unit body10'>{forecast?.temperatureUnit}</div>
										</div>
										<div className='stat'>
											<div className='label labels21'>Wind Speed</div>
											<div className='value body10'>{forecast?.windSpeed}</div>
											<div className='unit body10'></div>
										</div>
										{lastUpdated && (
											<div className='stat'>
												<div className='label labels21'>Last Updated </div>
												<div className='value body10'>{format(timestamp, 'MM-dd-yy h:mm a')}</div>
												<div className='unit body10'></div>
											</div>
										)}
									</div>
								);
							}
						})}
				</div>
			</div>
		</ForecastStyle>
	);
};
